export const convertJson = (pulledJson) => {
	const encodedJson = JSON.parse(window.atob(pulledJson));
	const newJsonType = [];
	for (var item in encodedJson) {
		newJsonType.push(
			{
				coordinates: {
					lat: parseFloat(encodedJson[item]['lat_lng']['lat']),
					lng: parseFloat(encodedJson[item]['lat_lng']['lng']),
				},
				redirect: _createValidRedirectURL(encodedJson[item]['link'])
			}
		);
	}
	return newJsonType;
}

const _createValidRedirectURL = url => `${window.location.origin}${url}`;

export default convertJson;


// WEBPACK FOOTER //
// ./js/Views/Modules/AllLocationsMap/JsonHandler.js